import { render, staticRenderFns } from "./Tipos_productos.vue?vue&type=template&id=2cfb65a4"
import script from "./Tipos_productos.vue?vue&type=script&lang=js"
export * from "./Tipos_productos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports